// components/Solutions.js - Homepage Version with Better Fonts
import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const Solutions = () => {
  const solutions = [
    {
      title: 'LV Systems',
      slug: 'lv',
      desc: 'Low voltage distribution, VFDs, and MCC panels',
      image: '/images/solutions/lv-panel-building.jpg',
      specs: '415V, VFDs, MCCs'
    },
    {
      title: 'MV Systems',
      slug: 'mv',
      desc: 'Medium voltage switchgear and protection systems',
      image: '/images/solutions/mv-switchgear.jpg',
      specs: '11kV, 33kV'
    },
    {
      title: 'Solar Energy',
      slug: 'solar',
      desc: 'Residential, commercial, and industrial solar solutions',
      image: '/images/solutions/solar-installation.jpg',
      specs: '1kW - 1MW+'
    },
    {
      title: 'Digital Energy',
      slug: 'digital-energy',
      desc: 'Smart monitoring, power quality meters, and analytics',
      image: '/images/solutions/digital-energy.jpg',
      specs: 'IoT, Analytics, Power Quality'
    },
    {
      title: 'Industrial Automation',
      slug: 'automation',
      desc: 'PLC, SCADA, and control systems for automation',
      image: '/images/solutions/automation.jpg',
      specs: 'PLC, SCADA, DCS'
    },
    {
      title: 'Backup Power',
      slug: 'backup-power',
      desc: 'UPS, Generators, ATS, and Battery Storage for critical loads',
      image: '/images/solutions/backup-power.jpg',
      specs: 'UPS, Generators, ATS, Batteries'
    }
  ];

  return (
    <section id="solutions" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-[#006D77] font-semibold text-sm uppercase tracking-wider inline-block bg-[#006D77]/10 px-4 py-1.5 rounded-full">
            Our Solutions
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-4 tracking-tight">
            Electrical Solutions for <span className="text-[#006D77]">Every Need</span>
          </h2>
          <p className="text-gray-600 text-lg mt-3">Comprehensive solutions across LV, MV, Solar, Digital Energy, Automation, and Backup Power</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {solutions.map((item, idx) => (
            <Link
              key={idx}
              to={`/solutions/${item.slug}`}
              className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="h-64 overflow-hidden relative">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  onError={(e) => {
                    e.target.src = `https://picsum.photos/seed/${item.slug}/800/600`;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="flex items-center text-xs text-white/60 mb-1">
                    <MapPin size={12} className="mr-1" />
                    Kenya & East Africa
                  </div>
                  <h3 className="text-2xl font-extrabold mb-1 tracking-tight">{item.title}</h3>
                  <p className="text-sm text-white/80 mb-2">{item.desc}</p>
                  <span className="inline-block text-xs bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full">
                    {item.specs}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
